import Vue from 'vue'
import Vuex from 'vuex'

import testModule from './module/test.js'
import tokenModule from './module/token.js' //	token
import cartModule from './module/cart.js'   //	cart
import pptModule from './module/ppt.js'     //	ppt
import ZoomPic from './module/ZoomPic.js'     //	ppt

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        test: testModule,
        token: tokenModule,
        cart: cartModule,
        ppt: pptModule,
        ZoomPic:ZoomPic
    }
})
